export default "__VITE_ASSET__eHW5MV48__"